import { render } from "./DmoPerfettoUnreleased.vue?vue&type=template&id=2bd47b54&scoped=true&ts=true&style=width%3A%20100%25%3B%20height%3A%20100%25"
import script from "./DmoPerfettoUnreleased.vue?vue&type=script&lang=ts"
export * from "./DmoPerfettoUnreleased.vue?vue&type=script&lang=ts"

import "./DmoPerfettoUnreleased.vue?vue&type=style&index=0&id=2bd47b54&scoped=true&lang=css"
import "./DmoPerfettoUnreleased.vue?vue&type=style&index=1&id=2bd47b54&lang=css"

import exportComponent from "/data/landun/workspace/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2bd47b54"]])

export default __exports__